// extracted by mini-css-extract-plugin
export default {"img-outer":"style_img-outer__4QLY5__oBlIk","img":"style_img__PSExq__oBlIk","loading":"style_loading__WCOwA__oBlIk","error":"style_error__+ECgZ__oBlIk"};